// Your web app's Firebase configuration
import { initializeApp } from 'firebase/app'
import { Capacitor } from '@capacitor/core'
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  signInWithRedirect,
  signInWithPopup,
  signInWithCredential,
  signOut as firebaseSignOut,
  getRedirectResult,
  GoogleAuthProvider
} from 'firebase/auth'
import { initializeFirestore, persistentLocalCache } from 'firebase/firestore'
import { getFunctions, httpsCallable } from 'firebase/functions'

const EXECUTE_MANUAL_BACKUP = false
const localhost = window.location.hostname.includes('localhost')

const firebaseConfig = {
  apiKey: 'AIzaSyAYvEWTlZ57Dsf0_pC0-CiWQvOXWnuFiJ8',
  authDomain: localhost ? 'compose.jvdsande.com' : window.location.hostname,
  projectId: 'jvdsande-compose',
  storageBucket: 'jvdsande-compose.appspot.com',
  messagingSenderId: '471043272063',
  appId: '1:471043272063:web:3bf0b1a49300a6341d3e4a'
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)

const provider = new GoogleAuthProvider()
export const auth = getAuth()

export async function signInWithGoogle() {
  if (Capacitor.getPlatform() !== 'ios') {
    return localhost
      ? (await signInWithPopup(auth, provider)).user
      : signInWithRedirect(auth, provider)
  }

  if (!Capacitor.isPluginAvailable('FirebaseAuthentication')) {
    throw new Error('Update the iOS wrapper to enable Google sign-in.')
  }

  const { FirebaseAuthentication } =
    await import('@capacitor-firebase/authentication')
  const result = await FirebaseAuthentication.signInWithGoogle({
    skipNativeAuth: true
  })
  const idToken = result.credential?.idToken
  if (!idToken) {
    throw new Error('Google sign-in did not return an ID token.')
  }

  const credential = GoogleAuthProvider.credential(
    idToken,
    result.credential?.accessToken
  )
  return (await signInWithCredential(auth, credential)).user
}

export async function signOut() {
  try {
    await firebaseSignOut(auth)
  } finally {
    if (
      Capacitor.getPlatform() === 'ios' &&
      Capacitor.isPluginAvailable('FirebaseAuthentication')
    ) {
      const { FirebaseAuthentication } =
        await import('@capacitor-firebase/authentication')
      await FirebaseAuthentication.signOut()
    }
  }
}

export const authPromise = setPersistence(auth, browserLocalPersistence)
  .then(async () => {
    const res =
      Capacitor.getPlatform() === 'ios' ? null : await getRedirectResult(auth)
    if (!res && !auth.currentUser) {
      return signInWithGoogle()
    }
    return auth.currentUser
  })
  .catch((err) => alert(err.message))

export const firestore = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  localCache: persistentLocalCache({})
})
export * as FS from 'firebase/firestore'

if (EXECUTE_MANUAL_BACKUP) {
  const functions = getFunctions(app)
  httpsCallable(functions, 'manualBackup')()
}
